import React from 'react';

// Stage A, Task 7 — top-level safety net. Before this, any uncaught render error anywhere in the
// tree unmounted the whole app to a blank white screen with no recovery path (audit §5, §27 P0
// №10). This never reports to any external service (no monitoring provider is in scope for Stage
// A) — it only prevents the blank-screen failure mode and gives the user a way out.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    } else {
      console.error('Unexpected render error:', error.message);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 24,
          gap: 16,
        }}>
          <h1 style={{ margin: 0 }}>Что-то пошло не так</h1>
          <p style={{ margin: 0, color: '#666', maxWidth: 420 }}>
            Произошла непредвиденная ошибка. Попробуйте обновить страницу — если проблема
            повторится, зайдите позже.
          </p>
          {process.env.NODE_ENV !== 'production' && this.state.error && (
            <pre style={{
              maxWidth: '90vw',
              overflow: 'auto',
              textAlign: 'left',
              background: '#f5f5f5',
              padding: 12,
              borderRadius: 8,
              fontSize: 12,
            }}>
              {String(this.state.error.stack || this.state.error.message)}
            </pre>
          )}
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 24px',
              borderRadius: 8,
              border: 'none',
              background: '#2b6cee',
              color: '#fff',
              fontSize: 16,
              cursor: 'pointer',
            }}
          >
            Обновить страницу
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
